import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { DiscountListItemType } from "@/features/cart/types/discount.type";
import { getDiscountsInfo } from "@/features/discounts/api/get-discounts-info";

type UseGetDiscountInfoParams = {
  params?: RequestInit;
  code: string;
  options?: Omit<
    UseQueryOptions<
      DiscountListItemType,
      unknown,
      DiscountListItemType,
      string[]
    >,
    "queryFn" | "queryKey"
  >;
};

export const useGetDiscountInfo = ({
  params,
  options,
  code,
}: UseGetDiscountInfoParams) => {
  return useQuery({
    queryKey: ["discounts-info", code],
    queryFn: () => getDiscountsInfo({ params, code, client: true }),
    ...options,
  });
};
